"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const locale = {
  placeholder: 'Wybierz godzinę'
};
var _default = exports.default = locale;